export default function usePreventDefault() {
    useEffect(() => {
        document.oncontextmenu = function (event) {
            // 阻止右键菜单
            event.preventDefault();
        };
    }, []);
}
